<template>
  <div ref="create_edit_customer_popup" class="modal fade create-edit-customer-popup"
       data-backdrop="static" tabindex="-1" role="dialog" :id="id">
      <Teleport to="body">
          <create-edit-customer v-if="openModalStatus || openModalStatusData" :customer-id-prop="customerId" :id="id"></create-edit-customer>
      </teleport>
</div>
</template>
<script>

import {EventBus} from "@/events/event-bus";
export default {
    name: "CreateEditCustomerParent",
    props: {
        id: {
            type: String,
            default() {
                return 'create_edit_customer_popup'
            }
        },
        openModalStatus: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            customerId: null,
        }
    },
    mounted() {
      $(this.$refs['create_edit_customer_popup']).on('shown.bs.modal', (e) => {
        $(`#addCustomersPopup`).css("z-index" , 1040);
      })
      $(this.$refs['create_edit_customer_popup']).on('hidden.bs.modal', (e) => {
        $(`#addCustomersPopup`).css("z-index" , 1050);
      })
        this.listenToTomSelectEvents();

    },
    computed: {
        openModalStatusData() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
    },
    methods: {
        listenToTomSelectEvents() {
            let vm = this;
            this.$nextTick(() => {
                EventBus.$on('setCustomerId', (data) => {
                    if(data){
                        vm.customerId = data;
                    }
                });
            });
            EventBus.$on('openModalCustomer', (value) => {
                vm.openModalStatus = true;
            });

        }
    }
}
</script>
